import AcademicInfoGroup from './model';
import create from './create';

AcademicInfoGroup.create = create;

export default AcademicInfoGroup;



// WEBPACK FOOTER //
// ./data/AcademicInfo/AcademicInfoGroup/index.js